import { forwardRef } from "react";
import { useId } from "react";
function SvgRawRemindIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#1D1D1D"
        d="M22 10.504c0-1.877-1.49-3.452-3.519-3.936C17.27 5.036 14.971 4 12.333 4 9.098 4 6.37 5.56 5.538 7.686A5.3 5.3 0 0 0 2 12.677c0 2.926 2.386 5.299 5.328 5.299a5.328 5.328 0 0 0 2.831-.81l.254 2.309c.056.532.739.717 1.062.29l2.309-3.049c.176.028.354.046.538.046a3.418 3.418 0 0 0 3.19-2.18C20.02 14.435 22 12.67 22 10.504Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawRemindIcon);
export default ForwardRef;
